function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
/**
 * The ButtonLike component provides an accessible component which acts like a button
 * and implements the same attributes expected on a button element. Use this component where
 * using Button is not allowed (like within a Button) otherwise always prefer using Button
 *
 * ## Related Components
 * - [Button](../Button/README.md)
 *
 * ## Usage
 *
 * ```jsx
 * <ButtonLike variant="outline" ctaType="secondary">My Label</ButtonLike>
 * ```
 *
 * ## Props
 */

var ButtonLike = /*#__PURE__*/function (_PureComponent) {
  _inherits(ButtonLike, _PureComponent);

  var _super = _createSuper(ButtonLike);

  function ButtonLike() {
    var _this;

    _classCallCheck(this, ButtonLike);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_handleKeyDown", function (e) {
      var keyCode = e.keyCode;
      var onClick = _this.props.onClick;
      var isSpacebar = keyCode === 32;
      var isEnter = keyCode === 13;
      if (isSpacebar || isEnter) onClick(_this._addNameAndValueToEvent(e));
    });

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (e) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          disabled = _this$props.disabled;
      if (disabled) return;
      if (typeof onClick !== 'function') return;
      onClick(_this._addNameAndValueToEvent(e));
    });

    _defineProperty(_assertThisInitialized(_this), "_addNameAndValueToEvent", function (e) {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          value = _this$props2.value;
      return _objectSpread(_objectSpread({}, e), {}, {
        target: _objectSpread(_objectSpread({}, e.target), {}, {
          name: name,
          value: value
        }),
        stopPropagation: e.stopPropagation.bind(e),
        preventDefault: e.preventDefault.bind(e)
      });
    });

    return _this;
  }

  _createClass(ButtonLike, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          qa = _this$props3.qa,
          children = _this$props3.children,
          className = _this$props3.className,
          ctaType = _this$props3.ctaType,
          variant = _this$props3.variant,
          background = _this$props3.background,
          disabled = _this$props3.disabled,
          iconOnly = _this$props3.iconOnly;
      return /*#__PURE__*/React.createElement("span", {
        className: Button.getClassName({
          className: className,
          variant: variant,
          ctaType: ctaType,
          background: background,
          iconOnly: iconOnly
        }).root,
        "data-qa": qa,
        "data-disabled": disabled ? 'disabled' : undefined,
        role: "button",
        tabIndex: 0,
        onClick: this._onClick,
        onKeyDown: this._handleKeyDown
      }, children);
    }
  }]);

  return ButtonLike;
}(PureComponent);

ButtonLike.defaultProps = {
  qa: '',
  className: '',
  variant: 'solid',
  ctaType: '',
  background: 'light',
  value: '',
  name: '',
  disabled: false,
  onClick: function onClick() {},
  iconOnly: false
};
ButtonLike.propTypes = {
  /**
   * QA selector attribute used to target important elements for test validation
   */
  qa: PropTypes.string,

  /**
   * Allows adding a custom class or series of classes on the component
   * useful for setting margin or padding
   */
  className: PropTypes.string,

  /**
   * The name of the button, which is submitted as a pair with the button’s value as part
   * of the form data.
   */
  name: PropTypes.string,

  /**
   * The initial value of the button. It defines the value associated with the button’s name
   * when it’s submitted with the form data. This value is passed to the server in params when the
   * form is submitted.
   */
  value: PropTypes.string,

  /**
   * Whether or not the button is disabled
   */
  disabled: PropTypes.bool,

  /**
   * Button only contains an icon like in the case of action buttons
   */
  iconOnly: PropTypes.bool,

  /**
   * Presentational variant to apply
   */
  variant: PropTypes.string,

  /**
   * The type of button in design language
   */
  ctaType: PropTypes.string,

  /**
   * Whether the button is on a dark or light background. Required for `outline` variants
   */
  background: PropTypes.string,

  /**
   * event callback to be called when a user clicks on the button or children within
   */
  onClick: PropTypes.func,

  /**
   * children to be rendered within the button. This is often a label but can be a label and
   * an icon. A button may also wrap any content to "Buttonify" it
   */
  children: PropTypes.node.isRequired
};
export default ButtonLike;